import API from './../../API.js';

export default async function get(id) {
  const result = await API.get(`scan-result-group/${id}`);
  return result.data.data;
}
